export default "__VITE_ASSET__7e2dd3f9__"